
import React, { useState } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronUp, PlusCircle } from 'feather-icons-react/build/IconComponents';
import { useDispatch, useSelector } from 'react-redux';
import { setToogleHeader } from '../../core/redux/action';
// import Select from 'react-select';
// import { DatePicker } from 'antd';
import AddCategoryList from '../../core/modals/inventory/addcategorylist';
import EditCategoryList from '../../core/modals/inventory/editcategorylist';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import Axios from 'axios';
import { useEffect } from 'react';
import { setcategotylist_data } from '../../core/redux/action';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { API_BASE_URL, DEL_CATEGORY, GET_CATEGORIES } from '../../Config';
import { getUserPermissions } from "../../UserPermissions";
import SpinLoader from '../loader/SpinLoader';


const CategoryList = () => {

    const [userDataSession, setUserDataSession] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        const userDataString = sessionStorage.getItem("userData");
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserDataSession(userData);
        } else {
            console.log("User data not found in sessionStorage");
            navigate('/');
        }
    }, []);

    const [permissions, setPermissions] = useState({
        isRead: 'd-none',
        isWrite: 'd-none',
        isDelete: 'd-none',
        isExport: 'd-none'
    });
    
    useEffect(() => {
        const perms = getUserPermissions("Categories");
        setPermissions(perms);
    }, []);

    const data = useSelector((state) => state.toggle_header);

    const dispatch = useDispatch();
    const dataSource = useSelector(state => state.categotylist_data) || [];
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (userDataSession && userDataSession.OrgId) {
            setLoading(true);
            Axios.get(`${API_BASE_URL}${GET_CATEGORIES}?OrgId=${userDataSession.OrgId}`)
                .then(response => {
                    if (response.data.Status) {
                        dispatch(setcategotylist_data(response.data.ResultData));
                        setLoading(false);
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    }, [dispatch, userDataSession]);

    // const [isFilterVisible, setIsFilterVisible] = useState(false);
    // const toggleFilterVisibility = () => {
    //     setIsFilterVisible((prevVisibility) => !prevVisibility);
    // };
    // const [selectedDate, setSelectedDate] = useState(new Date());
    // const handleDateChange = (date) => {
    //     setSelectedDate(date);
    // };

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Excel
        </Tooltip>
    );

    const renderCollapseTooltip = (props) => (
        <Tooltip id="refresh-tooltip" {...props}>
            Collapse
        </Tooltip>
    );

    const columns = [
        {
            title: 'Name',
            dataIndex: 'Name',
            sorter: (a, b) => a.Name.localeCompare(b.Name),
        },

        {
            title: 'Code',
            dataIndex: 'Code',
            sorter: (a, b) => a.Code.localeCompare(b.Code),
        },
        
        {
            title: 'Description',
            dataIndex: 'Description',
            sorter: (a, b) => a.Description.localeCompare(b.Description),
        },

        {
            title: 'Is Default',
            dataIndex: 'IsDefault',
            render: (IsDefault) => (
                <span className={`badge badge-${IsDefault === true ? 'linesuccess' : 'linedanger'}`}>
                    {IsDefault === true ? 'Yes' : 'No'}
                </span>
            ),
            sorter: (a, b) => (a.IsDefault ? 1 : -1) - (b.IsDefault ? 1 : -1),
        },

        {
            title: 'Status',
            dataIndex: 'IsActive',
            render: (IsActive) => (
                <span className={`badge badge-${IsActive === true ? 'success' : 'danger'}`}>
                    {IsActive === true ? 'Active' : 'Inactive'}
                </span>
            ),
            sorter: (a, b) => (a.IsActive ? 1 : -1) - (b.IsActive ? 1 : -1),
        },

        {
            title: 'Actions',
            dataIndex: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                        <Link
                            className={`me-2 p-2 ${permissions.isWrite}`}
                            to="#"
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRightCategoryEdit"
                            aria-controls="offcanvasRightCategoryEdit"
                            data-id="code"
                            onClick={() => showEditModal(record)}
                        >
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        <Link
                            className={`me-2 conform-text p-2 ${permissions.isDelete}`}
                            to="#"
                            onClick={() => showConfirmationAlert(record.Id)}
                        >
                            <i data-feather="trash-2" className="feather-trash-2"></i>
                        </Link>
                    </div>
                </td>
            ),
        },
    ];

    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (categoryId) => {
        MySwal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#00ff00',
            cancelButtonColor: '#ff0000',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                // Make a request to delete the category
                deleteCategory(categoryId);
            }
        });
    };

    const deleteCategory = (categoryId) => {

        const requestData = { "Id": categoryId, UpdatedBy: userDataSession.UserId };

        console.log(requestData, categoryId, 'resuwet data')

        Axios.post(`${API_BASE_URL}${DEL_CATEGORY}`, requestData)
            .then(response => {
                if (response.data.ResultData[0]['Status'] == 'Success') {
                    console.log(response.data)
                    // Show success message
                    MySwal.fire({
                        title: 'Deleted!',
                        text: 'Category has been deleted.',
                        icon: 'success',
                        confirmButtonColor: '#00ff00',
                    }).then(() => {
                        // Reload the page after the user clicks "OK"
                        window.location.reload();
                    });
                    // Optionally, you can update the category list after deletion
                } else {
                    // Show error message
                    MySwal.fire({
                        title: 'Error',
                        text: 'Failed to delete category.',
                        icon: 'error',
                        confirmButtonColor: '#00ff00',
                    });
                }
            })
            .catch(error => {
                console.error('Error deleting category:', error);
                // Show error message
                MySwal.fire({
                    title: 'Error',
                    text: 'Failed to delete category.',
                    icon: 'error',
                    confirmButtonColor: '#00ff00',
                });
            });
    };

    const [editCategoryObj, setEditCategoryObj] = useState([]);

    const showEditModal = (categoryObj) => {
        setEditCategoryObj(categoryObj); // Update the state with the ID of the category to edit
    };

    const filteredData = dataSource.filter(item =>
        item && // Check if item is defined
        (item.Name && item.Name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Code && item.Code.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Description && item.Description.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.Qty && item.Qty.toString().includes(searchQuery.toLowerCase()))
    );

    const handleDownloadExcel = () => {
        if (data.length === 0) {
            return; // Don't download if there is no data
        }

        // Create a new workbook
        const wb = XLSX.utils.book_new();

        // Convert your data to worksheet format
        const wsData = dataSource?.map((item) => ({
            'Category Name': item.Name,
            'Category Code': item.Code,
            'Created Date': item.CreatedOn,
            'Dscription': item.Description,
        }));

        const ws = XLSX.utils.json_to_sheet(wsData);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'CategoryData');

        // Save the workbook to a file
        XLSX.writeFile(wb, 'CategoryData.xlsx');
    };

    const generatePDF = () => {
        const doc = new jsPDF();

        // Set properties for PDF
        doc.setProperties({
            title: 'Attendance Report',
            author: 'Your Name',
            creator: 'Your Application'
        });

        // Add data to PDF
        const tableData = []; // Your data array here

        // Add a header row
        const headers = ['Name', 'Code', 'Description', 'Created Date'];
        tableData.push(headers);

        // Add rows
        dataSource.forEach(item => {
            const row = [];
            row.push(item.Name, item.Code, item.Description, item.CreatedOn);
            tableData.push(row);
        });

        // Generate table
        doc.autoTable({
            head: [headers],
            body: tableData.slice(1),
        });

        // Save the PDF
        doc.save('CategoryDatta.pdf');
    };

    return (
        <div>
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>Category</h4>
                                <h6>Manage your categories</h6>
                            </div>
                        </div>
                        <ul className="table-top-head">
                            <li className={` ${permissions.isExport}`} onClick={generatePDF}>
                                <OverlayTrigger placement="top" overlay={renderTooltip}>
                                    <Link>
                                        <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            <li className={` ${permissions.isExport}`} onClick={handleDownloadExcel}>
                                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <ImageWithBasePath src="assets/img/icons/excel.svg" alt="img" />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                            {/* <li>
                                <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <i data-feather="printer" className="feather-printer" />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
                            {/* <li>
                                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>

                                    <Link data-bs-toggle="tooltip" data-bs-placement="top">
                                        <RotateCcw />
                                    </Link>
                                </OverlayTrigger>
                            </li> */}
                            <li>
                                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>

                                    <Link
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        id="collapse-header"
                                        className={data ? "active" : ""}
                                        onClick={() => { dispatch(setToogleHeader(!data)) }}
                                    >
                                        <ChevronUp />
                                    </Link>
                                </OverlayTrigger>
                            </li>
                        </ul>
                        <div className={`page-btn ${permissions.isRead}`}>
                            <Link
                                to="#"
                                className="btn btn-added"
                                // data-bs-toggle="modal"
                                // data-bs-target="#add-category"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRightCategoryAdd"
                                aria-controls="offcanvasRightCategoryAdd"
                            >
                                <PlusCircle className="me-2" />
                                Add
                            </Link>
                        </div>
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-top">
                                <div className="search-set">
                                    <div className="input-group search-input">
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="form-control form-control-sm formsearch"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                        <span className="input-group-text bg-white">
                                            <i data-feather="search" className="feather-search"></i>
                                        </span>
                                    </div>
                                </div>
                                {/* <div className="search-path">
                                    <Link className={`btn btn-filter ${isFilterVisible ? "setclose" : ""}`} id="filter_search">
                                        <Filter
                                            className="filter-icon"
                                            onClick={toggleFilterVisibility}
                                        />
                                        <span onClick={toggleFilterVisibility}>
                                            <ImageWithBasePath src="assets/img/icons/closes.svg" alt="img" />
                                        </span>
                                    </Link>
                                </div> */}
                                
                            </div>
                          
                            <div className="table-responsive">
                                {loading ? (
                                    <SpinLoader/>
                                ) : (
                                    <Table columns={columns} dataSource={filteredData} />
                                )}
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
            <AddCategoryList />
            {/* <EditCategoryList /> */}
            <EditCategoryList categoryObj={editCategoryObj} />
        </div>
    )
}

export default CategoryList
